// extracted by mini-css-extract-plugin
export default {"logo":"LogoApe_logo__4+Tld","img_logo":"LogoApe_img_logo__WzDAp"};